"use strict";
import { memo } from "react";
import { Flex, Text } from "ui/src";
import { GoldenVerified } from "ui/src/components/icons/GoldenVerified";
import { iconSizes } from "ui/src/theme";
import { CombinedLogo } from "components/CurrencyLogo/SplitLogo";
import Badge from "components/badge/Badge";
import { OptionItem } from "components/lists/items/OptionItem";
import { PoolOptionItemContextMenu } from "components/lists/items/pools/PoolOptionItemContextMenu";
import {
  formatPoolFeePips,
  getPoolFeeModeLabel
} from "components/lists/items/pools/poolFeeDisplay";
import { ProtocolVersion } from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { shortenAddress } from "utilities/src/addresses";
function _PoolOptionItem({
  token0CurrencyInfo,
  token1CurrencyInfo,
  poolId,
  chainId,
  onPress,
  protocolVersion,
  hookAddress,
  feeTier,
  feeDetails,
  gaugeAddress,
  focusedRowControl
}) {
  const poolName = `${token0CurrencyInfo.currency.symbol}/${token1CurrencyInfo.currency.symbol}`;
  const feeModeLabel = getPoolFeeModeLabel(feeDetails);
  const displayedFee = feeDetails?.currentFeePips ?? feeTier;
  const optionItem = <OptionItem
    image={<CombinedLogo
      size={iconSizes.icon28}
      inputCurrencyInfo={token0CurrencyInfo}
      outputCurrencyInfo={token1CurrencyInfo}
      chainId={chainId}
    />}
    title={<Flex row gap="$spacing4" alignItems="center">
          <Text variant="body2">{poolName}</Text>
          {gaugeAddress && <GoldenVerified size={iconSizes.icon16} />}
        </Flex>}
    subtitle={protocolVersion !== ProtocolVersion.V4 ? <Text color="$neutral3" numberOfLines={1} variant="body3">
            {shortenAddress(poolId)}
          </Text> : void 0}
    badge={<Flex row gap="$spacing2" alignItems="center">
          {
      /* <Badge size="small" placement="start">
        {protocolVersion.toLowerCase()}
      </Badge> */
    }
          {hookAddress && <Badge size="small" placement="start">
              {shortenAddress(hookAddress, 4)}
            </Badge>}
          {feeModeLabel && <Badge size="small" placement="start">
              {feeModeLabel}
            </Badge>}
          <Badge size="small" placement="end">
            {formatPoolFeePips(displayedFee)}
          </Badge>
        </Flex>}
    focusedRowControl={focusedRowControl}
    onPress={onPress}
  />;
  return <PoolOptionItemContextMenu poolInfo={{ poolId, chain: chainId, gaugeAddress }}>
      {optionItem}
    </PoolOptionItemContextMenu>;
}
export const PoolOptionItem = memo(_PoolOptionItem);
